
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"x":"1","y":"1","width":"97.565","height":"97.565","rx":"10","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"M27.75 34.772h8.995C37.575 37.859 40.341 40 43.5 40c3.158 0 5.926-2.141 6.755-5.228H73.25A1.76 1.76 0 0075 33a1.76 1.76 0 00-1.75-1.772H50.255C49.425 28.141 46.658 26 43.5 26c-3.159 0-5.926 2.141-6.755 5.228H27.75A1.76 1.76 0 0026 33a1.76 1.76 0 001.75 1.772zM43.5 29a3.498 3.498 0 012.474 5.974A3.498 3.498 0 1143.5 29zm29.75 37.228H50.255C49.425 63.141 46.658 61 43.5 61c-3.159 0-5.926 2.141-6.755 5.228H27.75A1.76 1.76 0 0026 68a1.76 1.76 0 001.75 1.772h8.995C37.575 72.859 40.341 75 43.5 75c3.158 0 5.926-2.141 6.755-5.228H73.25A1.76 1.76 0 0075 68a1.76 1.76 0 00-1.75-1.772zM43.5 72a3.498 3.498 0 01-2.474-5.974A3.498 3.498 0 1143.5 72zm29.75-22.772h-8.995C63.425 46.141 60.659 44 57.5 44c-3.158 0-5.926 2.141-6.755 5.228H27.75A1.76 1.76 0 0026 51a1.76 1.76 0 001.75 1.772h22.995C51.575 55.859 54.342 58 57.5 58c3.159 0 5.926-2.141 6.755-5.228h8.995A1.76 1.76 0 0075 51a1.76 1.76 0 00-1.75-1.772zM57.5 54a3.498 3.498 0 01-2.474-5.974A3.498 3.498 0 1157.5 54z","fill":"#BF9C5F","fill-rule":"nonzero"}})])])
          )
        }
      }
    